<template>
  <div class="md:h-128 md:overflow-auto scroll-box">
    <slot />
  </div>
</template>
